// import axios from "axios";
// import { useEffect, useRef, useState } from "react";
// import {
//   FaBriefcase,
//   FaCalendarCheck,
//   FaDownload,
//   FaEye,
//   FaFileMedical,
//   FaIdCard,
//   FaRoad,
//   FaStar,
//   FaTimesCircle,
//   FaUser,
//   FaUserGraduate,
//   FaUserTie,
//   FaClock
// } from "react-icons/fa";
// import { API_BASE_URL } from "../utils/config";

// const DetailItem = ({ icon, label, value }) => (
//   <div className="flex items-start gap-3">
//     <div className="mt-1 text-blue-500">{icon}</div>
//     <div>
//       <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{label}</p>
//       <p className="text-sm font-bold text-gray-800">{value}</p>
//     </div>
//   </div>
// );

// const ShortJobApplicants = () => {
//   const [applications, setApplications] = useState([]);
//   const [totalApplicationsCount, setTotalApplicationsCount] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [scoreFilter, setScoreFilter] = useState(0);
//   const [roleFilter, setRoleFilter] = useState("");
//   const [dateFilter, setDateFilter] = useState("");
//   const [roleSearchQuery, setRoleSearchQuery] = useState("");
//   const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
//   const roleDropdownRef = useRef(null);
//   const [roles, setRoles] = useState([]);
//   const [selectedApplicant, setSelectedApplicant] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   // Profile Modal
//   const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
//   const [profileApp, setProfileApp] = useState(null);
//   const [profileDocs, setProfileDocs] = useState(null);
//   const [profileMedical, setProfileMedical] = useState([]);
//   const [profileExperience, setProfileExperience] = useState([]);
//   const [profileTab, setProfileTab] = useState("basic");
//   const [profileLoading, setProfileLoading] = useState(false);

//   // Pagination states
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     totalPages: 1,
//     totalCount: 0,
//     limit: 10,
//   });

//   useEffect(() => {
//     fetchApplications();
//     fetchRoles();

//     const handleClickOutside = (event) => {
//       if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
//         setIsRoleDropdownOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const fetchRoles = async () => {
//     try {
//       const res = await axios.get(`${API_BASE_URL}/jobs/all`);
//       if (res.data.success) {
//         const shortJobs = res.data.jobPosts.filter(job => job.jobType === "short");
//         const formattedRoles = shortJobs.map((job, index) => ({
//           _id: job._id || index,
//           name: job.role
//         }));
//         const uniqueRoles = Array.from(new Set(formattedRoles.map(r => r.name)))
//           .map(name => formattedRoles.find(r => r.name === name));
//         setRoles(uniqueRoles);
//       }
//     } catch (err) {
//       console.error("Failed to fetch roles:", err);
//     }
//   };

//   const fetchApplications = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(`${API_BASE_URL}/applications/all`);
//       if (res.data.success) {
//         const allApps = res.data.applications || [];
//         setTotalApplicationsCount(allApps.length);
        
//         // Robust filtering for short jobs
//         const shortApps = allApps.filter(app => {
//           const job = app.jobId;
          
//           // 1. Check explicit jobType 'short'
//           if (job && job.jobType === "short") return true;
//           if (app.jobType === "short") return true;
          
//           // 2. Check for short-job specific properties as fallback
//           // This handles cases where jobType might be missing but timing data exists
//           if (job && (job.startTime || job.endTime || job.totalDuration)) {
//             return true;
//           }
          
//           return false;
//         });
        
//         setApplications(shortApps);
//         console.log("Filtered Short Apps:", shortApps.length, "out of", allApps.length);
//       }
//     } catch (err) {
//       setError("Failed to fetch applications. Please check your connection.");
//       console.error("Fetch Applications Error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDocumentUrl = (filePath) => {
//     if (!filePath) return "";
//     const relativePath = filePath.includes("uploads")
//       ? "uploads/" + filePath.split(/uploads[\\/]/).pop().replace(/\\/g, "/")
//       : filePath.replace(/\\/g, "/");
//     return `${API_BASE_URL.replace("/api", "")}/${relativePath}`;
//   };

//   const handleOpenModal = (app) => {
//     setSelectedApplicant(app);
//     setIsModalOpen(true);
//   };

//   const handleOpenProfileModal = async (app) => {
//     setProfileApp(app);
//     setProfileTab("basic");
//     setProfileDocs(null);
//     setProfileMedical([]);
//     setProfileExperience([]);
//     setIsProfileModalOpen(true);
//     setProfileLoading(true);
//     try {
//       const candidateId = app.candidateId?._id || app.candidateId;
//       if (candidateId) {
//         const [docsRes, medRes, expRes] = await Promise.allSettled([
//           axios.get(`${API_BASE_URL}/candidate/admin/${candidateId}`),
//           axios.get(`${API_BASE_URL}/medical-certificates/employee/${candidateId}`),
//           axios.get(`${API_BASE_URL}/candidate/all-experiences`)
//         ]);
//         if (docsRes.status === "fulfilled" && docsRes.value.data?.success) {
//           setProfileDocs(docsRes.value.data.data?.documents || null);
//         }
//         if (medRes.status === "fulfilled" && medRes.value.data?.success) {
//           setProfileMedical(medRes.value.data.data || []);
//         }
//         if (expRes.status === "fulfilled" && expRes.value.data?.success) {
//           const allExp = expRes.value.data.data || [];
//           const filteredExp = allExp.filter(exp => 
//             (exp.candidateId?._id === candidateId) || 
//             (exp.candidateId?.email === app.email) ||
//             (exp.email === app.email)
//           );
//           setProfileExperience(filteredExp);
//         }
//       }
//     } catch (e) {
//       console.error("Profile load error:", e);
//     } finally {
//       setProfileLoading(false);
//     }
//   };

//   const filteredApplications = applications.filter(app => {
//     const query = searchQuery.toLowerCase();
//     const matchesSearch =
//       `${app.firstName} ${app.lastName}`.toLowerCase().includes(query) ||
//       (app.jobId?.role || "").toLowerCase().includes(query) ||
//       (app.mobile || "").toLowerCase().includes(query);

//     const matchesScore = (app.technicalScore || 0) >= scoreFilter;
//     const matchesRole = roleFilter ? (app.jobId?.role === roleFilter) : true;

//     let matchesDate = true;
//     if (dateFilter) {
//       const appDate = new Date(app.appliedAt).toISOString().split('T')[0];
//       matchesDate = appDate === dateFilter;
//     }

//     return matchesSearch && matchesScore && matchesRole && matchesDate;
//   });

//   useEffect(() => {
//     setPagination(prev => ({
//       ...prev,
//       totalCount: filteredApplications.length,
//       totalPages: Math.ceil(filteredApplications.length / prev.limit),
//       currentPage: 1
//     }));
//   }, [filteredApplications.length, searchQuery, scoreFilter, roleFilter, dateFilter]);

//   const indexOfLastItem = pagination.currentPage * pagination.limit;
//   const indexOfFirstItem = indexOfLastItem - pagination.limit;
//   const currentItems = filteredApplications.slice(indexOfFirstItem, indexOfLastItem);

//   const handleUpdateScore = async (id, field, value) => {
//     const numericValue = (field === "status") ? value : Number(value);
//     try {
//       const res = await axios.post(`${API_BASE_URL}/applications/update-score`, {
//         applicationId: id,
//         [field]: numericValue,
//       });
//       if (res.data.success) {
//         setApplications((prev) =>
//           prev.map((app) => (app._id === id ? { ...app, [field]: numericValue } : app))
//         );
//       }
//     } catch (err) {
//       console.error("Update error:", err);
//     }
//   };

//   const clearFilters = () => {
//     setSearchQuery("");
//     setScoreFilter(0);
//     setRoleFilter("");
//     setDateFilter("");
//     setRoleSearchQuery("");
//   };

//   const getPageNumbers = () => {
//     const pageNumbers = [];
//     for (let i = 1; i <= pagination.totalPages; i++) {
//       if (i === 1 || i === pagination.totalPages || (i >= pagination.currentPage - 2 && i <= pagination.currentPage + 2)) {
//         pageNumbers.push(i);
//       } else if (i === pagination.currentPage - 3 || i === pagination.currentPage + 3) {
//         pageNumbers.push("...");
//       }
//     }
//     return pageNumbers;
//   };

//   return (
//     <div className="w-full min-h-screen p-2">
//       {/* Filters Section */}
//       <div className="p-3 mb-3 bg-white rounded-lg shadow-md">
//         <div className="flex flex-wrap items-center gap-2">
//           <div className="relative flex-1 min-w-[180px]">
//             <FaUserGraduate className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
//             <input
//               type="text"
//               placeholder="Search name, mobile, role..."
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               className="w-full pl-8 pr-3 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 outline-none"
//             />
//           </div>

//           <div className="relative" ref={roleDropdownRef}>
//             <button
//               onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
//               className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${roleFilter ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'}`}
//             >
//               <FaBriefcase className="text-xs" /> Role {roleFilter && `: ${roleFilter}`}
//             </button>
//             {isRoleDropdownOpen && (
//               <div className="absolute z-50 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
//                 <div className="p-2 border-b border-gray-100 bg-gray-50">
//                   <input type="text" placeholder="Search roles..." value={roleSearchQuery} onChange={(e) => setRoleSearchQuery(e.target.value)} onClick={e => e.stopPropagation()} className="w-full py-1 pl-2 text-xs border rounded-md" />
//                 </div>
//                 <div onClick={() => { setRoleFilter(""); setIsRoleDropdownOpen(false); }} className="px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer border-b font-medium">All Roles</div>
//                 {roles.filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase())).map(r => (
//                   <div key={r._id} onClick={() => { setRoleFilter(r.name); setIsRoleDropdownOpen(false); }} className="px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer">{r.name}</div>
//                 ))}
//               </div>
//             )}
//           </div>

//           <div className="relative w-[130px]">
//             <select className="w-full pl-2 pr-6 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 appearance-none" value={scoreFilter} onChange={(e) => setScoreFilter(Number(e.target.value))}>
//               <option value="0">All Scores</option>
//               <option value="60">60% & Above</option>
//               <option value="70">70% & Above</option>
//               <option value="80">80% & Above</option>
//             </select>
//             <div className="absolute inset-y-0 right-0 flex items-center pr-1 pointer-events-none"><FaStar className="text-[8px] text-gray-400" /></div>
//           </div>

//           <div className="relative w-[130px]">
//             <input type="date" value={dateFilter} onChange={(e) => setDateFilter(e.target.value)} className="w-full pl-2 pr-2 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500" />
//           </div>

//           {(searchQuery || scoreFilter > 0 || roleFilter || dateFilter) && (
//             <button onClick={clearFilters} className="h-8 px-3 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition">Clear</button>
//           )}
//         </div>
//       </div>

//       {error && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">{error}</div>}

//       <div className="p-0 mb-0 bg-white border shadow-lg rounded-2xl">
//         {loading ? (
//           <div className="flex flex-col items-center justify-center py-20 gap-4">
//             <div className="w-10 h-10 border-4 border-indigo-50 border-t-indigo-600 rounded-full animate-spin"></div>
//             <p className="text-xs font-bold text-gray-400 animate-pulse uppercase tracking-wider">Loading Applicants...</p>
//           </div>
//         ) : filteredApplications.length > 0 ? (
//           <div className="overflow-x-auto bg-white shadow-lg rounded-xl">
//             <table className="min-w-full">
//               <thead className="text-sm text-left text-white bg-gradient-to-r from-green-500 to-blue-600">
//                 <tr>
//                   <th className="py-2 text-center">Candidate Name</th>
//                   <th className="py-2 text-center">Applied Role</th>
//                   <th className="py-2 text-center">Shift Timing</th>
//                   <th className="py-2 text-center">Avg Score</th>
//                   <th className="py-2 text-center">Status</th>
//                   <th className="py-2 text-center">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-50">
//                 {currentItems.map((app) => (
//                   <tr key={app._id} className="border-b hover:bg-gray-50 transition-colors text-xs text-center">
//                     <td className="px-2 py-3">
//                       <div className="font-bold text-gray-900">{app.firstName} {app.lastName}</div>
//                       <div className="text-[10px] text-gray-500">{new Date(app.appliedAt).toLocaleDateString()}</div>
//                     </td>
//                     <td className="px-2 py-3">
//                       <span className="px-2 py-1 bg-blue-50 text-blue-600 rounded-full text-[10px]">{app.jobId?.role || "Short Job"}</span>
//                     </td>
//                     <td className="px-2 py-3">
//                       <div className="flex flex-col items-center text-gray-600 font-medium">
//                         <div className="flex items-center gap-1"><FaClock size={10} className="text-blue-400" /> {app.jobId?.startTime} - {app.jobId?.endTime}</div>
//                         <div className="text-[10px] text-blue-600 font-bold uppercase">{app.jobId?.totalDuration}</div>
//                       </div>
//                     </td>
//                     <td className="px-2 py-3">
//                       <input type="number" className="w-16 p-1 border rounded text-center font-bold bg-gray-50" value={app.technicalScore || 0} onChange={(e) => handleUpdateScore(app._id, "technicalScore", e.target.value)} />
//                     </td>
//                     <td className="px-2 py-3">
//                       <select value={app.status || "Applied"} onChange={(e) => handleUpdateScore(app._id, "status", e.target.value)}
//                         className={`px-2 py-1 rounded-full text-[10px] font-bold border-0 outline-none cursor-pointer ${app.status === 'Selected' ? 'bg-green-100 text-green-700' : app.status === 'Rejected' ? 'bg-red-100 text-red-700' : 'bg-yellow-100 text-yellow-700'}`}>
//                         <option value="Applied">APPLIED</option>
//                         <option value="Selected">SELECTED</option>
//                         <option value="Rejected">REJECTED</option>
//                         <option value="On Hold">ON HOLD</option>
//                       </select>
//                     </td>
//                     <td className="px-2 py-3">
//                       <div className="flex justify-center gap-2">
//                         <button onClick={() => handleOpenProfileModal(app)} className="px-3 py-1 bg-violet-50 text-violet-700 hover:bg-violet-600 hover:text-white rounded-xl border border-violet-200 font-bold text-[10px] flex items-center gap-1"><FaUser size={10}/> Profile</button>
//                         <button onClick={() => handleOpenModal(app)} className="px-3 py-1 bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white rounded-xl border border-indigo-100 font-bold text-[10px] flex items-center gap-1"><FaEye size={10}/> View</button>
//                         <button onClick={() => app.resume && window.open(formatDocumentUrl(app.resume), '_blank')} className="px-3 py-1 bg-emerald-50 text-emerald-600 hover:bg-emerald-600 hover:text-white rounded-xl border border-emerald-100 font-bold text-[10px] flex items-center gap-1"><FaDownload size={10}/> Resume</button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
            
//             {/* Pagination */}
//             <div className="flex flex-col sm:flex-row items-center justify-between px-6 py-4 bg-gray-50 border-t gap-4">
//               <div className="text-sm text-gray-600">Showing <span className="font-bold">{indexOfFirstItem + 1}</span> to <span className="font-bold">{Math.min(indexOfLastItem, filteredApplications.length)}</span> of <span className="font-bold">{filteredApplications.length}</span></div>
//               <div className="flex items-center gap-1">
//                 <button onClick={() => setPagination(p => ({...p, currentPage: Math.max(1, p.currentPage - 1)}))} disabled={pagination.currentPage === 1} className="px-3 py-1.5 border rounded-lg bg-white hover:bg-gray-50 disabled:opacity-50 text-xs">Prev</button>
//                 {getPageNumbers().map((n, i) => (
//                   <button key={i} onClick={() => typeof n === 'number' && setPagination(p => ({...p, currentPage: n}))} className={`w-8 h-8 text-xs font-bold rounded-lg ${pagination.currentPage === n ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 border'}`}>{n}</button>
//                 ))}
//                 <button onClick={() => setPagination(p => ({...p, currentPage: Math.min(pagination.totalPages, p.currentPage + 1)}))} disabled={pagination.currentPage === pagination.totalPages} className="px-3 py-1.5 border rounded-lg bg-white hover:bg-gray-50 disabled:opacity-50 text-xs">Next</button>
//               </div>
//             </div>
//           </div>
//         ) : (
//           <div className="py-24 text-center">
//             <FaUserGraduate size={48} className="mx-auto text-gray-200 mb-4" />
//             <h3 className="text-lg font-bold text-gray-900">No short job applicants found</h3>
//             <p className="text-sm text-gray-400 max-w-md mx-auto mt-2">
//               Applicants will only appear here if they applied for a job marked as "Short Job". 
//               Currently showing 0 out of {totalApplicationsCount} total applications found in system.
//             </p>
//             <div className="mt-6">
//                <button onClick={() => fetchApplications()} className="px-4 py-2 bg-blue-600 text-white rounded-lg text-xs font-bold hover:bg-blue-700 transition-all">
//                  Refresh Data
//                </button>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* View Details Modal */}
//       {isModalOpen && selectedApplicant && (
//         <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
//           <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300">
//             <div className="px-8 py-6 bg-gradient-to-r from-blue-600 to-indigo-700 text-white flex justify-between items-start">
//               <div>
//                 <h2 className="text-2xl font-bold">{selectedApplicant.firstName} {selectedApplicant.lastName}</h2>
//                 <div className="flex items-center gap-2 mt-1 opacity-90 text-[10px] font-bold uppercase tracking-widest"><FaBriefcase size={10}/> {selectedApplicant.jobId?.role} • {selectedApplicant.jobId?.department}</div>
//               </div>
//               <button onClick={() => setIsModalOpen(false)} className="p-2 hover:bg-white/20 rounded-xl transition-all"><FaTimesCircle size={20}/></button>
//             </div>
            
//             <div className="p-8 space-y-6 max-h-[70vh] overflow-y-auto no-scrollbar">
//               <div className="grid grid-cols-2 gap-4">
//                 <div className="p-4 bg-blue-50 rounded-2xl border border-blue-100">
//                   <p className="text-[10px] font-bold text-blue-400 uppercase tracking-widest mb-1">Shift Timing</p>
//                   <p className="text-sm font-bold text-gray-900">{selectedApplicant.jobId?.startTime} - {selectedApplicant.jobId?.endTime}</p>
//                 </div>
//                 <div className="p-4 bg-indigo-50 rounded-2xl border border-indigo-100">
//                   <p className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest mb-1">Duration</p>
//                   <p className="text-sm font-bold text-indigo-600">{selectedApplicant.jobId?.totalDuration}</p>
//                 </div>
//               </div>
              
//               <div className="grid grid-cols-2 gap-y-4">
//                 <DetailItem label="Email" value={selectedApplicant.email} icon={<FaUserGraduate size={14}/>} />
//                 <DetailItem label="Mobile" value={selectedApplicant.mobile} icon={<FaStar size={14}/>} />
//                 <DetailItem label="Location" value={selectedApplicant.currentLocation} icon={<FaBriefcase size={14}/>} />
//                 <DetailItem label="Experience" value={`${selectedApplicant.experience || 0} Years`} icon={<FaRoad size={14}/>} />
//               </div>

//               <div className="flex gap-4">
//                 <button onClick={() => setIsModalOpen(false)} className="flex-1 py-4 bg-gray-900 text-white rounded-2xl font-bold hover:bg-black transition-all">Close View</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Profile Modal */}
//       {isProfileModalOpen && profileApp && (
//         <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
//           <div className="bg-white w-full max-w-4xl rounded-2xl shadow-2xl overflow-hidden relative animate-in zoom-in-95 duration-300">
//             <div className="px-8 py-6 bg-gradient-to-br from-indigo-600 to-violet-700 text-white flex justify-between items-center">
//               <div className="flex items-center gap-4">
//                 <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center text-2xl font-bold uppercase">{profileApp.firstName[0]}{profileApp.lastName[0]}</div>
//                 <div>
//                   <h2 className="text-2xl font-bold">{profileApp.firstName} {profileApp.lastName}</h2>
//                   <p className="text-xs opacity-80 uppercase font-bold tracking-widest">{profileApp.jobId?.role} • Short Job Applicant</p>
//                 </div>
//               </div>
//               <button onClick={() => setIsProfileModalOpen(false)} className="p-2 hover:bg-white/20 rounded-xl transition-all"><FaTimesCircle size={24}/></button>
//             </div>

//             <div className="flex border-b">
//               {['basic', 'education', 'experience'].map(tab => (
//                 <button key={tab} onClick={() => setProfileTab(tab)} className={`px-8 py-4 text-xs font-bold uppercase tracking-widest transition-all border-b-2 ${profileTab === tab ? 'text-indigo-600 border-indigo-600' : 'text-gray-400 border-transparent hover:text-gray-600'}`}>{tab}</button>
//               ))}
//             </div>

//             <div className="p-8 max-h-[60vh] overflow-y-auto no-scrollbar">
//               {profileLoading ? (
//                 <div className="py-20 text-center"><div className="w-8 h-8 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mx-auto mb-4"></div><p className="text-xs font-bold text-gray-400 uppercase tracking-widest">Loading Profile...</p></div>
//               ) : (
//                 <div className="animate-in fade-in duration-500">
//                   {profileTab === 'basic' && (
//                     <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
//                       <DetailItem label="Full Name" value={`${profileApp.firstName} ${profileApp.lastName}`} icon={<FaUser />} />
//                       <DetailItem label="Email" value={profileApp.email} icon={<FaUserGraduate />} />
//                       <DetailItem label="Mobile" value={profileApp.mobile} icon={<FaStar />} />
//                       <DetailItem label="Location" value={profileApp.currentLocation} icon={<FaBriefcase />} />
//                       <DetailItem label="Salary" value={profileApp.salary || "Not Set"} icon={<FaStar />} />
//                       <DetailItem label="Shift" value={`${profileApp.jobId?.startTime} - ${profileApp.jobId?.endTime}`} icon={<FaClock />} />
//                     </div>
//                   )}
//                   {profileTab === 'education' && (
//                     <div className="grid grid-cols-2 gap-8">
//                       <DetailItem label="Qualification" value={profileApp.highestQualification} icon={<FaIdCard />} />
//                       <DetailItem label="Institution" value={profileApp.institution} icon={<FaUserGraduate />} />
//                       <DetailItem label="Department" value={profileApp.department} icon={<FaBriefcase />} />
//                       <DetailItem label="Percentage" value={profileApp.percentage ? `${profileApp.percentage}%` : "N/A"} icon={<FaStar />} />
//                     </div>
//                   )}
//                   {profileTab === 'experience' && (
//                     <div className="space-y-6">
//                       <DetailItem label="Total Experience" value={`${profileApp.experience || 0} Years`} icon={<FaRoad />} />
//                       <div className="p-6 bg-gray-50 rounded-2xl border border-gray-100">
//                         <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-4">Work Summary</p>
//                         <p className="text-sm text-gray-600 leading-relaxed italic">"{profileApp.skills || "No skills summary provided"}"</p>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>

//             <div className="p-8 border-t flex gap-4">
//               <button onClick={() => profileApp.resume && window.open(formatDocumentUrl(profileApp.resume), '_blank')} className="flex-1 py-4 bg-emerald-50 text-emerald-700 rounded-2xl font-bold hover:bg-emerald-100 transition-all flex items-center justify-center gap-2"><FaDownload /> Download Resume</button>
//               <button onClick={() => setIsProfileModalOpen(false)} className="flex-1 py-4 bg-gray-900 text-white rounded-2xl font-bold hover:bg-black transition-all">Close Profile</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ShortJobApplicants;


import axios from "axios";
import { useEffect, useRef, useState } from "react";
import {
  FaBriefcase,
  FaCalendarCheck,
  FaDownload,
  FaEye,
  FaFileMedical,
  FaIdCard,
  FaRoad,
  FaStar,
  FaTimesCircle,
  FaUser,
  FaUserGraduate,
  FaUserTie,
  FaClock
} from "react-icons/fa";

const API_BASE_URL = 'https://ingrainhirebackend.ingrainsystems.com/api';

const DetailItem = ({ icon, label, value }) => (
  <div className="flex items-start gap-3">
    <div className="mt-1 text-blue-500">{icon}</div>
    <div>
      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{label}</p>
      <p className="text-sm font-bold text-gray-800">{value || "N/A"}</p>
    </div>
  </div>
);

const ShortJobApplicants = () => {
  const [applications, setApplications] = useState([]);
  const [totalApplicationsCount, setTotalApplicationsCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [scoreFilter, setScoreFilter] = useState(0);
  const [roleFilter, setRoleFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [roleSearchQuery, setRoleSearchQuery] = useState("");
  const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
  const roleDropdownRef = useRef(null);
  const [roles, setRoles] = useState([]);
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Profile Modal
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [profileApp, setProfileApp] = useState(null);
  const [profileDocs, setProfileDocs] = useState(null);
  const [profileMedical, setProfileMedical] = useState([]);
  const [profileExperience, setProfileExperience] = useState([]);
  const [profileTab, setProfileTab] = useState("basic");
  const [profileLoading, setProfileLoading] = useState(false);

  // Pagination states
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 10,
  });

  // Get clientId from localStorage
  const getClientId = () => {
    return localStorage.getItem('clientId') || localStorage.getItem('clientCustomId') || '';
  };

  useEffect(() => {
    fetchApplications();
    fetchRoles();

    const handleClickOutside = (event) => {
      if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
        setIsRoleDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchRoles = async () => {
    try {
      const clientId = getClientId();
      const res = await axios.get(`${API_BASE_URL}/jobs/all/${clientId}`);
      if (res.data.success) {
        const jobs = res.data.jobPosts || res.data.data || [];
        const shortJobs = jobs.filter(job => job.jobType === "short");
        const formattedRoles = shortJobs.map((job, index) => ({
          _id: job._id || index,
          name: job.role
        }));
        const uniqueRoles = Array.from(new Set(formattedRoles.map(r => r.name)))
          .map(name => formattedRoles.find(r => r.name === name));
        setRoles(uniqueRoles);
      }
    } catch (err) {
      console.error("Failed to fetch roles:", err);
    }
  };

  const fetchApplications = async () => {
    try {
      setLoading(true);
      setError("");
      const clientId = getClientId();
      // API: GET /api/applications/all/:clientId
      const res = await axios.get(`${API_BASE_URL}/applications/all/${clientId}`);
      
      if (res.data.success) {
        const allApps = res.data.applications || res.data.data || [];
        setTotalApplicationsCount(allApps.length);
        
        // Filter for short jobs
        const shortApps = allApps.filter(app => {
          const job = app.jobId;
          
          // Check explicit jobType 'short'
          if (job && job.jobType === "short") return true;
          if (app.jobType === "short") return true;
          
          // Check for short-job specific properties
          if (job && (job.startTime || job.endTime || job.totalDuration)) {
            return true;
          }
          
          return false;
        });
        
        setApplications(shortApps);
        console.log("Filtered Short Apps:", shortApps.length, "out of", allApps.length);
      } else {
        setError(res.data.message || "Failed to fetch applications");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch applications. Please check your connection.");
      console.error("Fetch Applications Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const formatDocumentUrl = (filePath) => {
    if (!filePath) return "";
    // If it's already a full URL
    if (filePath.startsWith('http')) return filePath;
    const baseUrl = API_BASE_URL.replace("/api", "");
    const relativePath = filePath.includes("uploads")
      ? "uploads/" + filePath.split(/uploads[\\/]/).pop().replace(/\\/g, "/")
      : filePath.replace(/\\/g, "/");
    return `${baseUrl}/${relativePath}`;
  };

  const handleOpenModal = (app) => {
    setSelectedApplicant(app);
    setIsModalOpen(true);
  };

  const handleOpenProfileModal = async (app) => {
    setProfileApp(app);
    setProfileTab("basic");
    setProfileDocs(null);
    setProfileMedical([]);
    setProfileExperience([]);
    setIsProfileModalOpen(true);
    setProfileLoading(true);
    
    try {
      const clientId = getClientId();
      const candidateId = app.candidateId?._id || app.candidateId;
      
      if (candidateId) {
        // Fetch all data parallelly
        const [docsRes, medRes, expRes] = await Promise.allSettled([
          axios.get(`${API_BASE_URL}/candidate/admin/${candidateId}?clientId=${clientId}`),
          axios.get(`${API_BASE_URL}/medical-certificates/employee/${candidateId}?clientId=${clientId}`),
          axios.get(`${API_BASE_URL}/candidate/all-experiences/${clientId}`)
        ]);
        
        if (docsRes.status === "fulfilled" && docsRes.value.data?.success) {
          setProfileDocs(docsRes.value.data.data?.documents || null);
        }
        
        if (medRes.status === "fulfilled" && medRes.value.data?.success) {
          setProfileMedical(medRes.value.data.data || []);
        }
        
        if (expRes.status === "fulfilled" && expRes.value.data?.success) {
          const allExp = expRes.value.data.data || [];
          const filteredExp = allExp.filter(exp => 
            (exp.candidateId?._id === candidateId) || 
            (exp.candidateId?.email === app.email) ||
            (exp.email === app.email)
          );
          setProfileExperience(filteredExp);
        }
      }
    } catch (e) {
      console.error("Profile load error:", e);
    } finally {
      setProfileLoading(false);
    }
  };

  const handleUpdateScore = async (id, field, value) => {
    const numericValue = (field === "status") ? value : Number(value);
    try {
      const clientId = getClientId();
      const res = await axios.post(`${API_BASE_URL}/applications/update-score`, {
        applicationId: id,
        clientId: clientId,
        [field]: numericValue,
      });
      if (res.data.success) {
        setApplications((prev) =>
          prev.map((app) => (app._id === id ? { ...app, [field]: numericValue } : app))
        );
      }
    } catch (err) {
      console.error("Update error:", err);
    }
  };

  const clearFilters = () => {
    setSearchQuery("");
    setScoreFilter(0);
    setRoleFilter("");
    setDateFilter("");
    setRoleSearchQuery("");
  };

  const filteredApplications = applications.filter(app => {
    const query = searchQuery.toLowerCase();
    const matchesSearch =
      `${app.firstName} ${app.lastName}`.toLowerCase().includes(query) ||
      (app.jobId?.role || "").toLowerCase().includes(query) ||
      (app.mobile || "").toLowerCase().includes(query);

    const matchesScore = (app.technicalScore || 0) >= scoreFilter;
    const matchesRole = roleFilter ? (app.jobId?.role === roleFilter) : true;

    let matchesDate = true;
    if (dateFilter) {
      const appDate = new Date(app.appliedAt).toISOString().split('T')[0];
      matchesDate = appDate === dateFilter;
    }

    return matchesSearch && matchesScore && matchesRole && matchesDate;
  });

  useEffect(() => {
    setPagination(prev => ({
      ...prev,
      totalCount: filteredApplications.length,
      totalPages: Math.ceil(filteredApplications.length / prev.limit),
      currentPage: 1
    }));
  }, [filteredApplications.length, searchQuery, scoreFilter, roleFilter, dateFilter]);

  const indexOfLastItem = pagination.currentPage * pagination.limit;
  const indexOfFirstItem = indexOfLastItem - pagination.limit;
  const currentItems = filteredApplications.slice(indexOfFirstItem, indexOfLastItem);

  const handleItemsPerPageChange = (limit) => {
    setPagination({
      currentPage: 1,
      limit: limit,
      totalCount: filteredApplications.length,
      totalPages: Math.ceil(filteredApplications.length / limit)
    });
  };

  const handlePrevPage = () => {
    if (pagination.currentPage > 1) {
      setPagination(prev => ({
        ...prev,
        currentPage: prev.currentPage - 1
      }));
    }
  };

  const handleNextPage = () => {
    if (pagination.currentPage < pagination.totalPages) {
      setPagination(prev => ({
        ...prev,
        currentPage: prev.currentPage + 1
      }));
    }
  };

  const handlePageClick = (page) => {
    setPagination(prev => ({
      ...prev,
      currentPage: page
    }));
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= pagination.totalPages; i++) {
      if (i === 1 || i === pagination.totalPages || (i >= pagination.currentPage - 2 && i <= pagination.currentPage + 2)) {
        pageNumbers.push(i);
      } else if (i === pagination.currentPage - 3 || i === pagination.currentPage + 3) {
        pageNumbers.push("...");
      }
    }
    return pageNumbers;
  };

  return (
    <div className="w-full min-h-screen p-2">
      {/* Filters Section */}
      <div className="p-3 mb-3 bg-white rounded-lg shadow-md">
        <div className="flex flex-wrap items-center gap-2">
          <div className="relative flex-1 min-w-[180px]">
            <FaUserGraduate className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
            <input
              type="text"
              placeholder="Search name, mobile, role..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-8 pr-3 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 outline-none"
            />
          </div>

          <div className="relative" ref={roleDropdownRef}>
            <button
              onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
              className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${roleFilter ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'}`}
            >
              <FaBriefcase className="text-xs" /> Role {roleFilter && `: ${roleFilter}`}
            </button>
            {isRoleDropdownOpen && (
              <div className="absolute z-50 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
                <div className="p-2 border-b border-gray-100 bg-gray-50">
                  <input 
                    type="text" 
                    placeholder="Search roles..." 
                    value={roleSearchQuery} 
                    onChange={(e) => setRoleSearchQuery(e.target.value)} 
                    onClick={e => e.stopPropagation()} 
                    className="w-full py-1 pl-2 text-xs border rounded-md" 
                  />
                </div>
                <div onClick={() => { setRoleFilter(""); setIsRoleDropdownOpen(false); }} className="px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer border-b font-medium">
                  All Roles
                </div>
                {roles.filter(r => r.name?.toLowerCase().includes(roleSearchQuery.toLowerCase())).map(r => (
                  <div key={r._id} onClick={() => { setRoleFilter(r.name); setIsRoleDropdownOpen(false); }} className="px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer">
                    {r.name}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="relative w-[130px]">
            <select 
              className="w-full pl-2 pr-6 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 appearance-none" 
              value={scoreFilter} 
              onChange={(e) => setScoreFilter(Number(e.target.value))}
            >
              <option value="0">All Scores</option>
              <option value="60">60% & Above</option>
              <option value="70">70% & Above</option>
              <option value="80">80% & Above</option>
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center pr-1 pointer-events-none">
              <FaStar className="text-[8px] text-gray-400" />
            </div>
          </div>

          <div className="relative w-[130px]">
            <input 
              type="date" 
              value={dateFilter} 
              onChange={(e) => setDateFilter(e.target.value)} 
              className="w-full pl-2 pr-2 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500" 
            />
          </div>

          {(searchQuery || scoreFilter > 0 || roleFilter || dateFilter) && (
            <button onClick={clearFilters} className="h-8 px-3 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition">
              Clear
            </button>
          )}
        </div>
      </div>

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4 flex items-center justify-between">
          <span>{error}</span>
          <button onClick={() => setError("")} className="text-red-500 hover:text-red-700">
            <FaTimesCircle />
          </button>
        </div>
      )}

      <div className="p-0 mb-0 bg-white border shadow-lg rounded-2xl">
        {loading ? (
          <div className="flex flex-col items-center justify-center py-20 gap-4">
            <div className="w-10 h-10 border-4 border-indigo-50 border-t-indigo-600 rounded-full animate-spin"></div>
            <p className="text-xs font-bold text-gray-400 animate-pulse uppercase tracking-wider">Loading Applicants...</p>
          </div>
        ) : filteredApplications.length > 0 ? (
          <div className="overflow-x-auto bg-white shadow-lg rounded-xl">
            <table className="min-w-full">
              <thead className="text-sm text-left text-white bg-gradient-to-r from-green-500 to-blue-600">
                <tr>
                  <th className="py-3 px-4 text-center text-xs font-bold uppercase tracking-wider">Candidate Name</th>
                  <th className="py-3 px-4 text-center text-xs font-bold uppercase tracking-wider">Applied Role</th>
                  <th className="py-3 px-4 text-center text-xs font-bold uppercase tracking-wider">Shift Timing</th>
                  <th className="py-3 px-4 text-center text-xs font-bold uppercase tracking-wider">Avg Score</th>
                  <th className="py-3 px-4 text-center text-xs font-bold uppercase tracking-wider">Status</th>
                  <th className="py-3 px-4 text-center text-xs font-bold uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {currentItems.map((app) => (
                  <tr key={app._id} className="border-b hover:bg-gray-50 transition-colors text-xs text-center">
                    <td className="px-4 py-3">
                      <div className="font-bold text-gray-900">{app.firstName} {app.lastName}</div>
                      <div className="text-[10px] text-gray-500">{new Date(app.appliedAt).toLocaleDateString()}</div>
                    </td>
                    <td className="px-4 py-3">
                      <span className="px-2 py-1 bg-blue-50 text-blue-600 rounded-full text-[10px] font-bold">
                        {app.jobId?.role || "Short Job"}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex flex-col items-center text-gray-600 font-medium">
                        <div className="flex items-center gap-1">
                          <FaClock size={10} className="text-blue-400" /> 
                          {app.jobId?.startTime || "N/A"} - {app.jobId?.endTime || "N/A"}
                        </div>
                        <div className="text-[10px] text-blue-600 font-bold uppercase">
                          {app.jobId?.totalDuration || "Flexible"}
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <input 
                        type="number" 
                        className="w-16 p-1 border rounded text-center font-bold bg-gray-50" 
                        value={app.technicalScore || 0} 
                        onChange={(e) => handleUpdateScore(app._id, "technicalScore", e.target.value)} 
                      />
                    </td>
                    <td className="px-4 py-3">
                      <select 
                        value={app.status || "Applied"} 
                        onChange={(e) => handleUpdateScore(app._id, "status", e.target.value)}
                        className={`px-2 py-1 rounded-full text-[10px] font-bold border-0 outline-none cursor-pointer ${
                          app.status === 'Selected' ? 'bg-green-100 text-green-700' : 
                          app.status === 'Rejected' ? 'bg-red-100 text-red-700' : 
                          'bg-yellow-100 text-yellow-700'
                        }`}
                      >
                        <option value="Applied">APPLIED</option>
                        <option value="Selected">SELECTED</option>
                        <option value="Rejected">REJECTED</option>
                        <option value="On Hold">ON HOLD</option>
                      </select>
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex justify-center gap-2">
                        <button 
                          onClick={() => handleOpenProfileModal(app)} 
                          className="px-3 py-1 bg-violet-50 text-violet-700 hover:bg-violet-600 hover:text-white rounded-xl border border-violet-200 font-bold text-[10px] flex items-center gap-1"
                        >
                          <FaUser size={10}/> Profile
                        </button>
                        <button 
                          onClick={() => handleOpenModal(app)} 
                          className="px-3 py-1 bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white rounded-xl border border-indigo-100 font-bold text-[10px] flex items-center gap-1"
                        >
                          <FaEye size={10}/> View
                        </button>
                        {app.resume && (
                          <button 
                            onClick={() => window.open(formatDocumentUrl(app.resume), '_blank')} 
                            className="px-3 py-1 bg-emerald-50 text-emerald-600 hover:bg-emerald-600 hover:text-white rounded-xl border border-emerald-100 font-bold text-[10px] flex items-center gap-1"
                          >
                            <FaDownload size={10}/> Resume
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            }</table>
            
            {/* Pagination */}
            {filteredApplications.length > 0 && (
              <div className="flex flex-col items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50 sm:flex-row">
                <div className="flex flex-wrap items-center gap-2 text-sm text-gray-700">
                  <span>Showing</span>
                  <span className="font-medium">{indexOfFirstItem + 1}</span>
                  <span>to</span>
                  <span className="font-medium">{Math.min(indexOfLastItem, filteredApplications.length)}</span>
                  <span>of</span>
                  <span className="font-medium">{filteredApplications.length}</span>
                  <span>results</span>

                  <select
                    value={pagination.limit}
                    onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
                    className="p-1 ml-2 text-sm border rounded-lg"
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                </div>

                <div className="flex items-center gap-2 mt-2 sm:mt-0">
                  <button
                    onClick={handlePrevPage}
                    disabled={pagination.currentPage === 1}
                    className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${
                      pagination.currentPage === 1
                        ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                        : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                    }`}
                  >
                    Previous
                  </button>

                  <div className="flex items-center gap-1">
                    {getPageNumbers().map((page, index) => (
                      <button
                        key={index}
                        onClick={() => typeof page === 'number' && handlePageClick(page)}
                        disabled={page === "..."}
                        className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                          page === "..."
                            ? "text-gray-500 cursor-default"
                            : pagination.currentPage === page
                            ? "bg-blue-600 text-white"
                            : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
                        }`}
                      >
                        {page}
                      </button>
                    ))}
                  </div>

                  <button
                    onClick={handleNextPage}
                    disabled={pagination.currentPage === pagination.totalPages}
                    className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${
                      pagination.currentPage === pagination.totalPages
                        ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                        : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                    }`}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="py-24 text-center">
            <FaUserGraduate size={48} className="mx-auto text-gray-200 mb-4" />
            <h3 className="text-lg font-bold text-gray-900">No short job applicants found</h3>
            <p className="text-sm text-gray-400 max-w-md mx-auto mt-2">
              Applicants will only appear here if they applied for a job marked as "Short Job". 
              Currently showing 0 out of {totalApplicationsCount} total applications found in system.
            </p>
            <div className="mt-6">
              <button 
                onClick={() => fetchApplications()} 
                className="px-4 py-2 bg-blue-600 text-white rounded-lg text-xs font-bold hover:bg-blue-700 transition-all"
              >
                Refresh Data
              </button>
            </div>
          </div>
        )}
      </div>

      {/* View Details Modal */}
      {isModalOpen && selectedApplicant && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
          <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300">
            <div className="px-8 py-6 bg-gradient-to-r from-blue-600 to-indigo-700 text-white flex justify-between items-start">
              <div>
                <h2 className="text-2xl font-bold">{selectedApplicant.firstName} {selectedApplicant.lastName}</h2>
                <div className="flex items-center gap-2 mt-1 opacity-90 text-[10px] font-bold uppercase tracking-widest">
                  <FaBriefcase size={10}/> {selectedApplicant.jobId?.role} • {selectedApplicant.jobId?.department || "Short Job"}
                </div>
              </div>
              <button onClick={() => setIsModalOpen(false)} className="p-2 hover:bg-white/20 rounded-xl transition-all">
                <FaTimesCircle size={20}/>
              </button>
            </div>
            
            <div className="p-8 space-y-6 max-h-[70vh] overflow-y-auto no-scrollbar">
              <div className="grid grid-cols-2 gap-4">
                <div className="p-4 bg-blue-50 rounded-2xl border border-blue-100">
                  <p className="text-[10px] font-bold text-blue-400 uppercase tracking-widest mb-1">Shift Timing</p>
                  <p className="text-sm font-bold text-gray-900">{selectedApplicant.jobId?.startTime} - {selectedApplicant.jobId?.endTime}</p>
                </div>
                <div className="p-4 bg-indigo-50 rounded-2xl border border-indigo-100">
                  <p className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest mb-1">Duration</p>
                  <p className="text-sm font-bold text-indigo-600">{selectedApplicant.jobId?.totalDuration}</p>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-y-4">
                <DetailItem label="Email" value={selectedApplicant.email} icon={<FaUserGraduate size={14}/>} />
                <DetailItem label="Mobile" value={selectedApplicant.mobile} icon={<FaStar size={14}/>} />
                <DetailItem label="Location" value={selectedApplicant.currentLocation} icon={<FaBriefcase size={14}/>} />
                <DetailItem label="Experience" value={`${selectedApplicant.experience || 0} Years`} icon={<FaRoad size={14}/>} />
              </div>

              <div className="flex gap-4">
                <button onClick={() => setIsModalOpen(false)} className="flex-1 py-4 bg-gray-900 text-white rounded-2xl font-bold hover:bg-black transition-all">
                  Close View
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Profile Modal */}
      {isProfileModalOpen && profileApp && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
          <div className="bg-white w-full max-w-4xl rounded-2xl shadow-2xl overflow-hidden relative animate-in zoom-in-95 duration-300">
            <div className="px-8 py-6 bg-gradient-to-br from-indigo-600 to-violet-700 text-white flex justify-between items-center">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center text-2xl font-bold uppercase">
                  {profileApp.firstName?.[0]}{profileApp.lastName?.[0]}
                </div>
                <div>
                  <h2 className="text-2xl font-bold">{profileApp.firstName} {profileApp.lastName}</h2>
                  <p className="text-xs opacity-80 uppercase font-bold tracking-widest">{profileApp.jobId?.role} • Short Job Applicant</p>
                </div>
              </div>
              <button onClick={() => setIsProfileModalOpen(false)} className="p-2 hover:bg-white/20 rounded-xl transition-all">
                <FaTimesCircle size={24}/>
              </button>
            </div>

            <div className="flex border-b">
              {['basic', 'education', 'experience'].map(tab => (
                <button 
                  key={tab} 
                  onClick={() => setProfileTab(tab)} 
                  className={`px-8 py-4 text-xs font-bold uppercase tracking-widest transition-all border-b-2 ${
                    profileTab === tab ? 'text-indigo-600 border-indigo-600' : 'text-gray-400 border-transparent hover:text-gray-600'
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>

            <div className="p-8 max-h-[60vh] overflow-y-auto no-scrollbar">
              {profileLoading ? (
                <div className="py-20 text-center">
                  <div className="w-8 h-8 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mx-auto mb-4"></div>
                  <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">Loading Profile...</p>
                </div>
              ) : (
                <div className="animate-in fade-in duration-500">
                  {profileTab === 'basic' && (
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
                      <DetailItem label="Full Name" value={`${profileApp.firstName} ${profileApp.lastName}`} icon={<FaUser />} />
                      <DetailItem label="Email" value={profileApp.email} icon={<FaUserGraduate />} />
                      <DetailItem label="Mobile" value={profileApp.mobile} icon={<FaStar />} />
                      <DetailItem label="Location" value={profileApp.currentLocation} icon={<FaBriefcase />} />
                      <DetailItem label="Salary" value={profileApp.salary || "Not Set"} icon={<FaStar />} />
                      <DetailItem label="Shift" value={`${profileApp.jobId?.startTime} - ${profileApp.jobId?.endTime}`} icon={<FaClock />} />
                    </div>
                  )}
                  {profileTab === 'education' && (
                    <div className="grid grid-cols-2 gap-8">
                      <DetailItem label="Qualification" value={profileApp.highestQualification} icon={<FaIdCard />} />
                      <DetailItem label="Institution" value={profileApp.institution} icon={<FaUserGraduate />} />
                      <DetailItem label="Department" value={profileApp.department} icon={<FaBriefcase />} />
                      <DetailItem label="Percentage" value={profileApp.percentage ? `${profileApp.percentage}%` : "N/A"} icon={<FaStar />} />
                    </div>
                  )}
                  {profileTab === 'experience' && (
                    <div className="space-y-6">
                      <DetailItem label="Total Experience" value={`${profileApp.experience || 0} Years`} icon={<FaRoad />} />
                      <div className="p-6 bg-gray-50 rounded-2xl border border-gray-100">
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-4">Work Summary</p>
                        <p className="text-sm text-gray-600 leading-relaxed italic">"{profileApp.skills || "No skills summary provided"}"</p>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="p-8 border-t flex gap-4">
              {profileApp.resume && (
                <button 
                  onClick={() => window.open(formatDocumentUrl(profileApp.resume), '_blank')} 
                  className="flex-1 py-4 bg-emerald-50 text-emerald-700 rounded-2xl font-bold hover:bg-emerald-100 transition-all flex items-center justify-center gap-2"
                >
                  <FaDownload /> Download Resume
                </button>
              )}
              <button 
                onClick={() => setIsProfileModalOpen(false)} 
                className="flex-1 py-4 bg-gray-900 text-white rounded-2xl font-bold hover:bg-black transition-all"
              >
                Close Profile
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShortJobApplicants;